import React from "react";

const GoogleMapEmbed: React.FC = () => {
  return (
    <div>
      <iframe
        title="Google Map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d638.2868597734231!2d70.82661287530672!3d22.809394865298977!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39598d277cb00983%3A0xd983b75ff84232e9!2sShlok%20Heights%2C%20Kayaji%20Plot%2C%20Sardar%20Nagar%2C%20Morbi%2C%20Gujarat%20363641!5e0!3m2!1sen!2sin!4v1742031978084!5m2!1sen!2sin"
        width="1250"
        height="385"
        style={{ border: "0" }}
        allowFullScreen={true} 
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default GoogleMapEmbed;
